// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"BK-z","smallCardRow":"CK-z","largeCardRow":"DK-z","productSearchRow":"EK-z","curatedRow":"FK-z"};